import styled from 'styled-components/native';

export default styled.Text<{ labelColor?: string }>`
  color: ${({ labelColor, theme }) => (labelColor ? labelColor : theme.optionsGroup.text)};
  flex: 1;
  font-size: 15px;
`;
